export default "__VITE_ASSET__OtxidsTY__"